import { eventConstants } from '../constants';
import { eventService } from '../../services';

export const eventActions = {
  eventsList,
  addEvent,
  getEvent,
  updateEvent
}

/*
ACTION: Events List
*/
function eventsList(pageID, perPage) {
  return dispatch => {
    dispatch(request());
    return eventService.eventsList(pageID, perPage)
      .then(
        response => {
          dispatch(success(response.data.body.calendars, response.data.body.data.total));
        },
        error => {
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: eventConstants.GETALL_REQUEST } }
  function success(items, total) { return { type: eventConstants.GETALL_SUCCESS, items, total } }
  function failure(error) { return { type: eventConstants.GETALL_FAILURE, error } }
}

/*
ACTION: Add Event
*/
function addEvent(addToast, formData) {
  return dispatch => {
    dispatch(request());
    return eventService.addEvent(formData)
      .then(
        response => {
          addToast('عملیات با موفقیت انجام شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(true));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: eventConstants.ADD_REQUEST } }
  function success(status) { return { type: eventConstants.ADD_SUCCESS, status } }
  function failure(error) { return { type: eventConstants.ADD_FAILURE, error } }
}

/*
ACTION: Get Event By ID
*/
function getEvent(eventID) {
  return dispatch => {
    dispatch(request());
    return eventService.getEvent(eventID)
      .then(
        response => {
          console.log(response);
          dispatch(success(response.data.body));
        },
        error => {
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: eventConstants.GET_REQUEST } }
  function success(item) { return { type: eventConstants.GET_SUCCESS, item } }
  function failure(error) { return { type: eventConstants.GET_FAILURE, error } }
}

/*
ACTION: Update Event
*/
function updateEvent(addToast, formData) {
  return dispatch => {
    dispatch(request());
    return eventService.updateEvent(formData)
      .then(
        response => {
          addToast('بروزرسانی با موفقیت انجام شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(true));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: eventConstants.UPDATE_REQUEST } }
  function success(status) { return { type: eventConstants.UPDATE_SUCCESS, status } }
  function failure(error) { return { type: eventConstants.UPDATE_FAILURE, error } }
}